; (function () {

    var service = function (constants) {
        
        return {
            getMaterials: function (entity) {
                return entity.color_scheme;
            }
        };
    };

    angular.module('valleyCraftApp').service('materialSelector', ['constants', service]);
})();
